import { render, staticRenderFns } from "./FormReply.vue?vue&type=template&id=193cdff2&"
import script from "./FormReply.vue?vue&type=script&lang=ts&"
export * from "./FormReply.vue?vue&type=script&lang=ts&"
import style0 from "./FormReply.vue?vue&type=style&index=0&id=193cdff2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports